module.exports = __webpack_public_path__ + "img/logo_green4t_bg.4ef46775.png";